<template>
  <div class="auth">
    <transition name="list" mode="out-in">
      <div v-if="currentTab == 0" class="tab tab--0" key="tab0">
        <Headline subline="Unkompliziert & Sicher" headline="Authentifikationsverfahren wählen"/>
        <p>Um Sie vor einem Missbrauch Ihrer Daten zu schützen muss vor der Übertragung persönlicher Daten Ihre Identität festgestellt werden. Sie haben dabei die Wahl sich per Video-ID oder per Software-Zertifikat zu authentifizieren.</p>
        <div class="row margin-top--40">
          <div class="col-xs-12 col-sm-6">
            <div class="choose" @click="currentTab = 1">
              <Icon icon="auth" color="detailed"/>
              <div>
                <h3>Video-ID</h3>
                <p>Authentifizierung mittels Ihrer Webcam/Smartphone-Kamera und Ihrem Ausweis</p>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-sm-6">
            <div class="choose" @click="currentTab = 1">
              <Icon icon="certificate" color="detailed"/>
              <div>
                <h3>Zertifikatsdatei</h3>
                <p>Authentifizierung über Software-Zertifikat</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="currentTab == 1" class="tab tab--1" key="tab1">
        <Headline subline="Unkompliziert & Sicher" headline="Authentifizierung mit Video-ID"/>
        <p>Um Sie vor einem Missbrauch Ihrer Daten zu schützen muss vor der Übertragung persönlicher Daten Ihre Identität festgestellt werden. Sie haben dabei die Wahl sich per Video-ID oder per Software-Zertifikat zu authentifizieren.</p>
        <img src="../../assets/images/auth/tab1.svg" class="progress hide-mobile">
        <div class="row margin-top--40">
          <div class="col-xs-12 col-sm-6">
            <div class="choose" @click="currentTab = 2">
              <Icon icon="webcam" color="detailed"/>
              <div>
                <h3>Webcam</h3>
                <p>Identifikation über dieses Gerät</p>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-sm-6">
            <div class="choose" @click="currentTab = 2">
              <Icon icon="phone" color="detailed"/>
              <div>
                <h3>Smartphone-Kamera</h3>
                <p>Identifikation über externes Gerät</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="currentTab == 2" class="tab tab--2" key="tab2">
        <Headline subline="Unkompliziert & Sicher" headline="Authentifizierung mit Video-ID"/>
        <p>Um Sie vor einem Missbrauch Ihrer Daten zu schützen muss vor der Übertragung persönlicher Daten Ihre Identität festgestellt werden. Sie haben dabei die Wahl sich per Video-ID oder per Software-Zertifikat zu authentifizieren.</p>
        <img src="../../assets/images/auth/tab2.svg" class="progress hide-mobile">
        <div class="row between-xs margin-top--40">
          <div class="col-xs-12 col-sm-7">
            <div class="cam">
              <video autoplay="true" ref="video" id="video" width="100%" height="450"></video>
              <img class="mask" src="../../assets/images/auth/maskId.svg">
              <div v-if="on" class="active">
                <p>Ihre Kamera ist nun aktiv</p>
                <span @click="stopCam">Deaktivieren</span>
              </div>
              <div v-else class="active active--not">
                <p>Ihre Kamera ist nicht aktiv</p>
                <span @click="initiateCam">Aktivieren</span>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-sm-4">
            <div class="steps">
              <h6>Benötigte Schritte</h6>
              <div class="greenline margin-top--10 margin-bottom--20"></div>
              <div class="step">
                <Icon icon="check" color="green" />
                <p>Halten Sie bitte die Vorderseite Ihres Ausweises in die Kamera.</p>
              </div>
              <div class="step">
                <Icon icon="wait" />
                <p>Neigen Sie Ihren Ausweis, damit die Holograme erkennbar sind.</p>
              </div>
              <div class="step">
                <Icon icon="wait" color="grey" />
                <p class="color-darkgrey">Halten Sie bitte die Rückseite Ihres Ausweises in die Kamera.</p>
              </div>
              <Button type="primary" text="weiter" class="margin-top--30" @click.native="nextTab"/>
            </div>
          </div>
        </div>
      </div>

      <div v-if="currentTab == 3" class="tab tab--3" key="tab3">
        <Headline subline="Unkompliziert & Sicher" headline="Authentifizierung mit Video-ID"/>
        <p>Um Sie vor einem Missbrauch Ihrer Daten zu schützen muss vor der Übertragung persönlicher Daten Ihre Identität festgestellt werden. Sie haben dabei die Wahl sich per Video-ID oder per Software-Zertifikat zu authentifizieren.</p>
        <img src="../../assets/images/auth/tab3.svg" class="progress hide-mobile">
        <div class="row between-xs margin-top--40">
          <div class="col-xs-12 col-sm-7">
            <div class="cam">
              <video autoplay="true" ref="video" id="video" width="100%" height="450"></video>
              <img class="mask" src="../../assets/images/auth/maskFace.svg">
              <div v-if="on" class="active">
                <p>Ihre Kamera ist nun aktiv</p>
                <span @click="stopCam">Deaktivieren</span>
              </div>
              <div v-else class="active active--not">
                <p>Ihre Kamera ist nicht aktiv</p>
                <span @click="initiateCam">Aktivieren</span>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-sm-4">
            <div class="steps">
              <h6>Benötigte Schritte</h6>
              <div class="greenline margin-top--10 margin-bottom--20"></div>
              <div class="step">
                <Icon icon="wait" />
                <p>Richten Sie ihr Gesicht nach der Markierung im Kamera-Bild aus.</p>
              </div>
              <Button type="primary" text="weiter" class="margin-top--30" @click.native="nextTab"/>
            </div>
          </div>
        </div>
      </div>

      <div v-if="currentTab == 4" class="tab tab--4" key="tab4">
        <Headline subline="Unkompliziert & Sicher" headline="Authentifizierung mit Video-ID"/>
        <p>Um Sie vor einem Missbrauch Ihrer Daten zu schützen muss vor der Übertragung persönlicher Daten Ihre Identität festgestellt werden. Sie haben dabei die Wahl sich per Video-ID oder per Software-Zertifikat zu authentifizieren.</p>
        <img src="../../assets/images/auth/tab4.svg" class="progress hide-mobile">
        <div class="row between-xs margin-top--40">
          <div class="col-xs-12 col-sm-7">
            <div class="form">
              <h6>Zu übermittelnde Daten</h6>
              <div class="greenline margin-top--10 margin-bottom--20"></div>
              <p>Mit dem abschließen des Vorgangs übermitteln Sie Ihren <b>Antrag auf Ausbildungsförderung (BAföG)</b> an das <b>Amt für Ausbildungsförderung Augsburg</b></p>
              <form class="margin-top--30">
                <InputText class="margin-bottom--10" name="id" type="text" pattern=".{10}" placeholder="10-stellig">
                   Ausweis-Nr.
                   <p slot="hint">Hallo was geht</p>
                </inputText>
                <InputText name="password" type="password">
                   Passwort
                   <p slot="hint">Hallo was geht</p>
                </inputText>
              </form>
            </div>
          </div>
          <div class="col-xs-12 col-sm-4">
            <div class="steps">
              <h6>Benötigte Schritte</h6>
              <div class="greenline margin-top--10 margin-bottom--20"></div>
              <div class="step">
                <Icon icon="wait" />
                <p>Geben Sie Ihre Ausweis-Nr. und Ihr Bürgerkonto-Passwort ein.</p>
              </div>
              <div class="step">
                <Icon icon="wait" color="grey" />
                <p>Sie sind nun authentifiziert und können die Datenübertragung durchführen.</p>
              </div>
              <Button type="primary" text="weiter" class="margin-top--30" @click.native="setDoneService"/>
            </div>
          </div>
        </div>
      </div>


    </transition>
  </div>
</template>

<script>
import classnames from 'classnames';
import { mapGetters, mapActions } from 'vuex';
import Headline from '../Headline/Headline';
import Button from '../Button/Button';
import Icon from '../Icon/Icon';
import InputText from '../formElements/InputText/InputText';

export default {
  name: 'Auth',
  components: {
    Headline,
    Button,
    Icon,
    InputText,
  },
  data() {
    return {
      currentTab: 0,
      video: {},
      stream: {},
      on: false,
    };
  },
  props: {
    serviceId: {
      type: Number,
      required: true,
    }
  },
  computed: {
    ...mapGetters({
      activeUser: 'auth/getUserSession',
    }),
  },
  methods: {
    ...mapActions({
      setDone: 'services/setDone',
    }),
    initiateCam() {
      this.video = this.$refs.video;
      if(navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        navigator.mediaDevices.getUserMedia({ video: true, audio: false }).then(stream => {
            this.video.srcObject = stream;
            this.stream = stream;
            this.video.play();
            this.on = true;
            setTimeout(() => this.snap(), 10000);
        }).catch(function(error) {
          console.log(error);
        });
      }
    },
    stopCam() {
      if(this.on) {
        this.video.pause();
        this.video.src = "";
        this.stream.getTracks()[0].stop();
        this.on = false;
        console.log("Vid off");
      }
    },
    snap() {
      this.video.pause();
    },
    nextTab() {
      this.stopCam();
      this.currentTab++
    },
    setDoneService() {
      this.setDone([this.activeUser.id, this.serviceId]);
      this.$router.push(`/services/${this.serviceId}`);
    },
  },
  mounted() {
    
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="./Auth.scss" lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Auth/Auth.vue